export default __webpack_public_path__ + "static/media/360-degrees.6a41eac9.svg";